[
    {
        "localeCode": "zh-CN",
        "localeDescription": "Chinese (Simpleified)",
        "show": false
    },
    {
        "localeCode": "hr-HR",
        "localeDescription": "Croatian",
        "show": true
    },
    {
        "localeCode": "cs-CZ",
        "localeDescription": "Czech",
        "show": true
    },
    {
        "localeCode": "da-DK",
        "localeDescription": "Danish",
        "show": true
    },
    {
        "localeCode": "nl-NL",
        "localeDescription": "Dutch",
        "show": true
    },
    {
        "localeCode": "en-GB",
        "localeDescription": "English (Great Britain)",
        "show": true
    },
    {
        "localeCode": "en-US",
        "localeDescription": "English (US)",
        "show": true
    },
    {
        "localeCode": "fi-FI",
        "localeDescription": "Finnish",
        "show": true
    },
    {
        "localeCode": "fr-FR",
        "localeDescription": "French",
        "show": true
    },
    {
        "localeCode": "de-DE",
        "localeDescription": "German",
        "show": true
    },
    {
        "localeCode": "el-GR",
        "localeDescription": "Greek",
        "show": true
    },
    {
        "localeCode": "he-IL",
        "localeDescription": "Hebrew",
        "show": false
    },
    {
        "localeCode": "hu-HU",
        "localeDescription": "Hungarian",
        "show": false
    },
    {
        "localeCode": "id-ID",
        "localeDescription": "Indonasian",
        "show": false
    },
    {
        "localeCode": "it-IT",
        "localeDescription": "Italian",
        "show": true
    },
    {
        "localeCode": "ja-JP",
        "localeDescription": "Japanese",
        "show": true
    },
    {
        "localeCode": "ko-KR",
        "localeDescription": "Korean",
        "show": true
    },
    {
        "localeCode": "no-NO",
        "localeDescription": "Norwegian",
        "show": true
    },
    {
        "localeCode": "pl-PL",
        "localeDescription": "Polish",
        "show": true
    },
    {
        "localeCode": "pt-BR",
        "localeDescription": "Portuguese (Brazil)",
        "show": false
    },
    {
        "localeCode": "pt-PT",
        "localeDescription": "Portuguese (Portugal)",
        "show": false
    },
    {
        "localeCode": "ro-RO",
        "localeDescription": "Romanian",
        "show": true
    },
    {
        "localeCode": "sk-SK",
        "localeDescription": "Slovak",
        "show": true
    },
    {
        "localeCode": "sl-SI",
        "localeDescription": "Slovenian",
        "show": true
    },
    {
        "localeCode": "es-ES",
        "localeDescription": "Spanish",
        "show": true
    }
]
